import React, { createContext, useContext, useState, ReactNode } from 'react';

interface CoachContextType {
  isAddingCoach: boolean;
  setIsAddingCoach: (value: boolean) => void;
  setBackHandler: (handler: () => void) => void;
  handleBackFromAddCoach: () => void;
}

const CoachContext = createContext<CoachContextType | undefined>(undefined);

export const CoachProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isAddingCoach, setIsAddingCoach] = useState(false);
  const [backHandler, setBackHandlerState] = useState<(() => void) | null>(null);

  const setBackHandler = (handler: () => void) => {
    setBackHandlerState(() => handler);
  };

  const handleBackFromAddCoach = () => {
    if (backHandler) {
      backHandler();
    }
  };

  return (
    <CoachContext.Provider 
      value={{ 
        isAddingCoach, 
        setIsAddingCoach,
        setBackHandler,
        handleBackFromAddCoach
      }}
    >
      {children}
    </CoachContext.Provider>
  );
};

export const useCoachContext = () => {
  const context = useContext(CoachContext);
  if (!context) {
    throw new Error('useCoachContext must be used within CoachProvider');
  }
  return context;
};
